// extracted by mini-css-extract-plugin
export var btnClassName = "TreatmentResultSection-module--btnClassName--842dc";
export var carouselStyling = "TreatmentResultSection-module--carouselStyling--f658e";
export var doubledImage = "TreatmentResultSection-module--doubledImage--c994a";
export var doubledSlide = "TreatmentResultSection-module--doubledSlide--8eb09";
export var fullImage = "TreatmentResultSection-module--fullImage--1f469";
export var headingContainerStyling = "TreatmentResultSection-module--headingContainerStyling--100f9";
export var slideImage = "TreatmentResultSection-module--slideImage--20d3e";
export var swiperSlide = "TreatmentResultSection-module--swiperSlide--15055";